export type ValidityStatus = {
  encryptedCardNumber: { isValid: boolean };
  encryptedExpiryDate: { isValid: boolean };
  encryptedSecurityCode: { isValid: boolean };
  holderName: null;
};

export type CheckedStatus = {
  billingAddress: boolean;
  encryptedCardNumber: boolean;
  encryptedExpiryMonth: boolean;
  encryptedExpiryYear: boolean;
  encryptedSecurityCode: boolean;
  holderName: boolean;
  socialSecurityNumber: boolean;
  taxNumber: boolean;
};

export type RefusalReasonType = {
  [key: string]: string;
};

export const paymentMethods: Record<string, string> = {
  scheme: 'scheme',
  googlepay: 'googlepay',
  applepay: 'applepay',
  paypal: 'paypal',
  groupklarna: 'groupklarna',
  klarna: 'klarna',
  klarna_account: 'klarna_account',
  giftcard: 'giftcard',
};
